module.exports = __webpack_public_path__ + "static/media/show-more.bb158ab6.svg";